import {
    Grid,
    TableBody,
    TableContainer,
    TableRow,
    Table,
    TableHead,
    Checkbox,
    withStyles,
    TableCell,
    Tooltip,
    DialogTitle,
    Chip,
    CircularProgress
} from '@material-ui/core';
import React, { useEffect, useState, useContext } from 'react';
import AppContext from '../../../../App/AppContext.js';
import { DeleteHolidayRecodrs, UserHolidays_ByDate } from '../../../../Core/Service/TCard-UserHoliday-service.js';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal.jsx';
import DialogComp from '../../../../Core/Modal/dialogModal.js';
import formatters from '../../../../Core/Grid/inputFormatter';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { SecondaryButton } from '../../../../Core/FormInput/AppButton';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';
import AddUpdateHoliday from './AddUpdateHoliday.jsx';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 16,
        padding: '2px 8px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '2px 8px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        height: '40px',
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const UserHoliday = ({ selectedDate, branchID, onClose }) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        errors: {},
        deLinkList: [],
        list: [],
        modalData: {},
        showEditModal: false,
        showConfirm: false
    });
    const [winWidth] = useWindowSize();
    const checkisMobile = winWidth < 1280;

    const CallApiBydate = async () => {
        setLoading(true);
        try {
            let res = await UserHolidays_ByDate(selectedDate);
            if (res.success) {
                setState((prev) => ({ ...prev, list: res.data.list }));
            } else {
                showToast('Failed to fetch holiday records');
            }
        } catch (error) {
            showToast('Error fetching holiday records');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedDate) {
            CallApiBydate();
        }
    }, [selectedDate]);

    const handleClick = (e, row) => {
        const { checked } = e.target;
        setState((prev) => {
            let selectedRecords = [...prev.deLinkList];
            let updatedList = [...prev.list];
            const recordIndex = selectedRecords.findIndex((r) => row.tCardUserHolidayRecordID === r.tCardUserHolidayRecordID);
            const selectedRecordIndex = updatedList.findIndex((r) => row.tCardUserHolidayRecordID === r.tCardUserHolidayRecordID);
            if (selectedRecordIndex !== -1) {
                updatedList[selectedRecordIndex].isSelected = checked;
            }
            if (checked && recordIndex === -1) {
                selectedRecords.push(row);
            } else if (!checked && recordIndex !== -1) {
                selectedRecords.splice(recordIndex, 1);
            }
            return { ...prev, deLinkList: selectedRecords, list: updatedList };
        });
    };

    const closeConfirmationModal = () => {
        setState((prev) => ({ ...prev, showConfirm: false }));
    };

    const deleteHolidayRecordsHandler = async () => {
        setState((prev) => ({ ...prev, loading: true }));
        const selectedIds = state.deLinkList.filter((record) => record.tCardUserHolidayRecordID != null).map((record) => record.tCardUserHolidayRecordID);
        let data = { Ids: selectedIds };
        try {
            let res = await DeleteHolidayRecodrs(data);
            if (res.success) {
                showToast('Records deleted successfully');
                closeConfirmationModal();
                setState((prev) => ({ ...prev, deLinkList: [] }));
                CallApiBydate();
            } else {
                showToast(res.message || 'Failed to delete records');
            }
        } catch (error) {
            showToast('An error occurred: ' + error.message);
        } finally {
            setState((prev) => ({ ...prev, loading: false }));
        }
    };

    const confirmationModalHandler = () => {
        setState((prev) => ({ ...prev, showConfirm: true }));
    };

    const handleAddEdit = (data) => {
        setState((prev) => ({ ...prev, modalData: data, showEditModal: true }));
    };

    const closeEditModal = (res) => {
        if (res) {
            showToast('Record updated successfully');
            CallApiBydate();
            setState((prev) => ({
                ...prev,
                modalData: null
            }));
        } else {
            setState((prev) => ({
                ...prev,
                // showEditModal: false,
                modalData: null
            }));
        }
    };

    const RenderTitle = () => {
        return (
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    <DialogTitle style={{ padding: 0 }}>View Holiday - {formatters.DateFormatter(selectedDate)}</DialogTitle>
                </Grid>
                <Grid item>
                    <SecondaryButton onClick={() => handleAddEdit(null)} style={{ whiteSpace: 'nowrap' }}>
                        Add Holiday
                    </SecondaryButton>
                </Grid>
            </Grid>
        );
    };

    if (loading) {
        return (
            <DialogComp maxWidth="lg" fullScreen={checkisMobile ? true : false} fullWidth>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '70vh' }}>
                    <CircularProgress />
                </Grid>
            </DialogComp>
        );
    }

    return (
        <DialogComp onClose={onClose} title={RenderTitle()} maxWidth="lg" fullScreen={checkisMobile ? true : false} fullWidth>
            <Grid container spacing={2} style={{ paddingBottom: 6 }}>
                <TableContainer
                    style={{
                        border: '1px solid rgba(0,0,0,0.2)',
                        height: 'calc(100vh - 455px)'
                    }}
                    className="custom-scroll"
                >
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell width={0.1}>
                                    <Grid container style={{ marginLeft: '5px' }}>
                                        {state.deLinkList.length > 0 && (
                                            <Chip
                                                icon={<DeleteOutlineIcon style={{ marginRight: -18 }} />}
                                                onClick={confirmationModalHandler}
                                                style={{
                                                    fontWeight: 'bold',
                                                    paddingRight: -10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                toolTipTitle={'Delete Selected Records'}
                                            />
                                        )}
                                    </Grid>
                                </StyledTableCell>
                                <StyledTableCell width={200}>
                                    <span style={{ display: checkisMobile ? 'flex' : 'block', alignItems: 'center', gap: '1px' }}>
                                        {/* {checkisMobile && <AddIcon onClick={() => handleAddEdit(null)} className="add_btn" />} */}
                                        User
                                    </span>
                                </StyledTableCell>
                                <StyledTableCell width={200}>Start Date</StyledTableCell>
                                <StyledTableCell width={200}>End Date</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {state.list.map((m) => (
                                <StyledTableRow key={m.tCardUserHolidayRecordID}>
                                    <StyledTableCell>
                                        <Tooltip title="Delete" arrow>
                                            <Checkbox title="Delete" name="isSelected" onChange={(e) => handleClick(e, m)} checked={m.isSelected || false} />
                                        </Tooltip>
                                        <EditIcon style={{ marginBottom: -7, marginLeft: 7, cursor: 'pointer' }} onClick={() => handleAddEdit(m)} />
                                    </StyledTableCell>
                                    <StyledTableCell style={{ cursor: 'pointer', fontWeight: 600, marginTop: 5 }}>{m.userName}</StyledTableCell>
                                    <StyledTableCell style={{ marginTop: 5 }}>{formatters.MonthShortFormatter(m.holidayStartDate)}</StyledTableCell>
                                    <StyledTableCell style={{ marginTop: 5 }}>{formatters.MonthShortFormatter(m.holidayEndDate)}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {state.showConfirm && (
                    <DialogComp title="Confirmation" onClose={closeConfirmationModal} maxWidth="md" fullWidth>
                        {state.loading ? (
                            <Grid container justifyContent="center" alignItems="center" style={{ height: '7vh' }}>
                                <CircularProgress />
                            </Grid>
                        ) : (
                            <ConfirmationModal
                                textAlign="center"
                                message="Are you sure you want to delete holiday records?"
                                handleSubmit={deleteHolidayRecordsHandler}
                                handleCancel={closeConfirmationModal}
                            />
                        )}
                    </DialogComp>
                )}
                {state.showEditModal && (
                    <DialogComp
                        title={state.modalData?.tCardUserHolidayRecordID ? 'Update' : 'Add'}
                        onClose={() => setState((prev) => ({ ...prev, showEditModal: false }))}
                        maxWidth="md"
                        fullWidth
                    >
                        <AddUpdateHoliday
                            selectedDate={selectedDate}
                            branchID={branchID}
                            userData={state.modalData}
                            onClose={(res) => {
                                if (res) {
                                    closeEditModal(res);
                                    setState((prev) => ({ ...prev, showEditModal: false }));
                                }
                            }}
                        />
                    </DialogComp>
                )}
            </Grid>
        </DialogComp>
    );
};

export default UserHoliday;
